import { ArrowUpRight, ArrowDownLeft, Plus, Banknote, RotateCcw, CreditCard, Coins, Receipt, PiggyBank, Gift } from "lucide-react";
import { BlueCheck } from "./common";

const META = {
  send: { icon: ArrowUpRight, tint: "text-foreground", bg: "bg-secondary" },
  receive: { icon: ArrowDownLeft, tint: "text-success", bg: "bg-success/10" },
  deposit: { icon: Plus, tint: "text-success", bg: "bg-success/10" },
  withdrawal: { icon: Banknote, tint: "text-foreground", bg: "bg-secondary" },
  refund: { icon: RotateCcw, tint: "text-success", bg: "bg-success/10" },
  fee: { icon: Receipt, tint: "text-foreground", bg: "bg-secondary" },
  card: { icon: CreditCard, tint: "text-foreground", bg: "bg-secondary" },
  crypto: { icon: Coins, tint: "text-foreground", bg: "bg-secondary" },
  savings_deposit: { icon: PiggyBank, tint: "text-foreground", bg: "bg-secondary" },
  savings_withdraw: { icon: PiggyBank, tint: "text-success", bg: "bg-success/10" },
  referral_bonus: { icon: Gift, tint: "text-success", bg: "bg-success/10" },
};

const STATUS_COLORS = {
  completed: "text-success", pending: "text-warning", processing: "text-warning",
  failed: "text-destructive", cancelled: "text-muted-foreground", reversed: "text-muted-foreground",
};

export function TxnRow({ t, onClick }) {
  const m = META[t.type] || META.send;
  const Icon = m.icon;
  const positive = t.amount >= 0;
  const date = new Date(t.timestamp).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  return (
    <button data-testid={`txn-row-${t.transaction_id}`} onClick={onClick}
      className="w-full flex items-center gap-3 py-3 text-left transition-colors hover:bg-secondary/50 rounded-xl px-2 -mx-2">
      <div className={`grid place-items-center w-11 h-11 rounded-full shrink-0 ${m.bg} ${m.tint}`}>
        <Icon size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-medium truncate capitalize flex items-center gap-1.5">
          <span className="truncate">{t.counterparty_name || t.type}</span>
          {t.counterparty_blue_check && <BlueCheck size={14} testid={`txn-badge-${t.transaction_id}`} />}
          {t.reaction && <span className="text-sm shrink-0" data-testid={`txn-reaction-${t.transaction_id}`}>{t.reaction}</span>}
        </div>
        <div className="text-xs text-muted-foreground truncate">
          {t.counterparty_cash_tag && <span className="font-mono normal-case">{t.counterparty_cash_tag} · </span>}
          {date} · <span className={`capitalize ${STATUS_COLORS[t.status] || ""}`}>{t.status}</span>
          {t.failure_reason ? ` · ${t.failure_reason}` : ""}
        </div>
      </div>
      <div className={`font-semibold font-mono text-sm shrink-0 ${positive ? "text-success" : "text-foreground"}`}>
        {positive ? "+" : "-"}{t.amount_display}
      </div>
    </button>
  );
}
